import { createRootRoute, HeadContent } from '@tanstack/react-router'
import { SiteLayout } from '@/components/site-layout'
import { Toaster } from '@/components/ui/sonner'

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { title: 'NEVER KNOWS BEST' },
      {
        name: 'description',
        content:
          '美しく・強く・速く。Webもアプリも自在に。あなたのアイデアを動かす技術。NEVER KNOWS BESTのアプリ・Webサービスと開発の取り組みをご紹介します。'
      }
    ]
  }),
  notFoundComponent: () => (
    <div>
      <h1>ページが見つかりません</h1>
      <p>URLをご確認ください。</p>
      <a href='/'>トップに戻る</a>
    </div>
  ),
  component: () => (
    <>
      <HeadContent />
      <SiteLayout />
      <Toaster />
    </>
  )
})
